import { compose, trim } from 'lodash/fp';
import { notEmpty } from '@mews-commander/utils';

export const isValidSearchTerm = compose(notEmpty, trim);
